import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React, { Component, useEffect, useState, useCallback, useContext, useMemo, useRef } from 'react'
import { _getMailingList, getAllPurchases } from '../services/requests'
import { AgGridReact } from 'ag-grid-react'; // AG Grid Component
import * as moment from 'moment';
import { CButton, CCard, CCardBody, CCol, CCollapse, CContainer, CFormInput, CFormLabel, CNavItem, CNavLink, CNavbar, CNavbarBrand, CNavbarNav, CNavbarToggler, CRow } from "@coreui/react-pro";
import { AuthContext } from '../context/authContext'
import inspireAfricaLogo from '../assets/ia-logo.png'
import { TableLoader } from "./tableLoader";
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx';


export const AdminPanel = () => {
    const gridRef = useRef();
    const authContext = useContext(AuthContext)
    const [purchaseData, setPurchaseData] = useState([])
    const [visible, setVisible] = useState(false)
    const [overview, setOverview] = useState(false)
    const [searchText, setSearchText] = useState('')
    const [totals, setTotals] = useState({})
    const [colDefs, setColDefs] = useState([
        { field: "firstName", pinned: true, valueGetter: (item) => { return item.data?.contacts[0]?.firstName }, flex: 1, filter: 'agTextColumnFilter', minWidth: 200, },
        { field: "lastName", valueGetter: (item) => { return item.data?.contacts[0]?.lastName }, flex: 1, filter: 'agTextColumnFilter', minWidth: 200 },
        { field: "email", valueGetter: (item) => { return item.data?.contacts[0]?.email }, flex: 1, filter: 'agTextColumnFilter', minWidth: 200 },
        { field: "company", valueGetter: (item) => { return item.data?.contacts[0]?.companyName }, flex: 1, filter: 'agTextColumnFilter', minWidth: 200 },
        { field: "paymentStatus", flex: 1, filter: 'agTextColumnFilter', minWidth: 200 },
        { field: "creationTime", valueGetter: (item) => { return dateFormatter(item.data?.timestamp)}, flex: 1, filter: 'agDateColumnFilter', minWidth: 200 },
        { field: "paymentDate", valueGetter: (item) => { return item.data?.paymentStatus === 'complete' ? dateFormatter(item.data?.updatedAt) : null }, flex: 1, filter: 'agDateColumnFilter', minWidth: 200 },
        { field: "totalTicketsPurchased", headerName: 'No of Seats', flex: 1, filter: 'agNumberColumnFilter', tooltipField: 'ticketBreakup', minWidth: 140 },
        { field: "totalAmount", valueGetter: (item) => { return formatToNGNCurrency(item.data?.totalAmount) }, flex: 1, minWidth: 200 },
    ]);

    const loadingOverlayComponent = useMemo(() => {
        return TableLoader;
    }, []);

    const dateFormatter = (date) => {
        return moment.utc(date).local().format('DD MMM YYYY - hh:mm A')
    }

    const formatToNGNCurrency = (number) => {
        // Check if the input is a valid number
        if (isNaN(number)) {
            console.error('Invalid input. Please provide a valid number.');
            return '';
        }

        const formatter = new Intl.NumberFormat('en-NG', {
            style: 'currency',
            currency: 'NGN',
            minimumFractionDigits: 2,
        });

        return formatter.format(number);
    }

    const fetchData = () => {
        gridRef.current.api.showLoadingOverlay()
        getAllPurchases().then((data) => {
            setTotals(data?.data?.body?.totals)
            setPurchaseData(data?.data?.body?.items)
        })
    }

    const onGridReady = useCallback(() => {
        fetchData()
    }, []);

    const onFilterOpened = useCallback((e) => {
        console.log('onFilterOpened', e);
    }, []);

    const onFilterChanged = useCallback((e) => {
        console.log('onFilterChanged', e);
        console.log(
            'gridRef.current.api.getFilterModel() =>',
            e.api.getFilterModel()
        );
    }, []);

    const onFilterModified = useCallback((e) => {
        console.log('onFilterModified', e);
        console.log('filterInstance.getModel() =>', e.filterInstance.getModel());
        console.log(
            'filterInstance.getModelFromUi() =>',
            e.filterInstance.getModelFromUi()
        );
    }, []);

    const exportData = (data, name = 'file.xlsx') => {
        const columnsToDelete = ['id', 'sort-index'];

        const modifiedData = data.map(item => {
            const newItem = { ...item };
            columnsToDelete.forEach(column => delete newItem[column]);
            return newItem;
        });
        const ws = XLSX.utils.json_to_sheet(modifiedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Main');
        XLSX.writeFile(wb, name);
    }

    return (
        <>
            <CNavbar expand="lg" colorScheme="dark" className="bg-black">
                <CContainer fluid className="navbar-container">
                    <CNavbarBrand href="#" className="navbar-logo">
                        <img
                            src={inspireAfricaLogo}
                            alt=""
                            width="125"
                            height="24"
                            className="d-inline-block align-top"
                        />
                    </CNavbarBrand>
                    <CNavbarToggler
                        aria-label="Toggle navigation"
                        aria-expanded={visible}
                        onClick={() => setVisible(!visible)}
                    />
                    <CCollapse className="navbar-collapse justify-between" visible={visible}>
                        <CNavbarNav>
                            <CNavItem>
                                <CNavLink className="navbar-item" href="https://www.inspireafricaconference.com/">
                                    Home
                                </CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink className="navbar-item" href="https://www.inspireafricaconference.com/agenda">
                                    Agenda
                                </CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink className="navbar-item" href="https://www.inspireafricaconference.com/home/#speakers">
                                    Speakers
                                </CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink className="navbar-item" href="https://www.inspireafricaconference.com/home/#who-should-attend">
                                    Who Should Attend?
                                </CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink className="navbar-item" href="https://www.inspireafricaconference.com/home/#sponsors">
                                    Sponsors
                                </CNavLink>
                            </CNavItem>
                        </CNavbarNav>
                        <CButton type="submit" color="danger" variant="outline" className="danger-btn" onClick={() => {
                            setTimeout(() => {
                                authContext.setLoggedIn(false)
                            }, 500)
                        }}> LOG OUT </CButton>
                    </CCollapse>
                </CContainer>
            </CNavbar>
            <div className="admin-panel-main">
                <div className="table-container">
                    <div className="table-filter-div-1 mt-3">
                        <CFormInput
                            className="search-filter"
                            type="text"
                            placeholder="Search by name, email, company..."
                            delay={500}
                            onChange={(event) => { setSearchText(event.target.value) }} />
                        <div className="d-flex gap-2">
                            <CButton color="success" variant="outline" onClick={async () => {
                                const resp = await _getMailingList()
                                exportData(resp?.data?.body?.items, 'mailing-list.xlsx') 
                                }} className="export-btn">Export Mailing List Data</CButton>
                            <CButton color="success" variant="outline" onClick={() => { exportData(purchaseData, 'registrations.xlsx') }} className="export-btn">Export Registration Data</CButton>
                        </div>
                    </div>
                    <>
                        <a href="#" class="button-overview" onClick={() => setOverview(!overview)}>{overview ? 'Hide' : 'Show'} Overview</a>
                        <div style={{ width: '95%' }}>
                            <CCollapse visible={overview}>
                                <CCard className="mt-3 mb-3">
                                    <CCardBody>
                                        <p className="mb-0" style={{ fontWeight: 'bold', color: 'rgb(76 163 11)'}}>Complete</p>
                                        <div className="table-filter-div">
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Entries</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalEntries} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Tickets Purchased</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalTicketsPurchased} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Amount Paid</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={formatToNGNCurrency(totals?.totalAmount)} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Conference Access</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalConferenceAccess} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total SVGP Masterclass</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalSvgp} readOnly plainText />
                                            </div>
                                        </div>
                                        <p className="mb-0 mt-3" style={{ fontWeight: 'bold', color: '#ff1744' }}>Incomplete</p>
                                        <div className="table-filter-div">
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Entries</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalEntriesIncomplete} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Tickets Purchased</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalTicketsPurchasedIncomplete} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Amount Paid</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={formatToNGNCurrency(totals?.totalAmountIncomplete)} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total Conference Access</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalConferenceAccessIncomplete} readOnly plainText />
                                            </div>
                                            <div>
                                                <CFormLabel htmlFor="staticEmail" className="heading-1">Total SVGP Masterclass</CFormLabel>
                                                <CFormInput type="text" id="staticEmail" className="heading-2" defaultValue={totals?.totalSvgpIncomplete} readOnly plainText />
                                            </div>
                                        </div>
                                    </CCardBody>
                                </CCard>
                            </CCollapse>
                        </div>
                    </>
                    <div
                        className="ag-theme-quartz-auto-dark table-container-2"
                        style={{ height: '80vh' }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            className="w-95"
                            quickFilterText={searchText}
                            rowData={purchaseData}
                            columnDefs={colDefs}
                            pagination={true}
                            suppressRowVirtualisation={true}
                            loadingOverlayComponent={loadingOverlayComponent}
                            paginationPageSize={20}
                            onGridReady={onGridReady}
                            onFilterOpened={onFilterOpened}
                            onFilterChanged={onFilterChanged}
                            onFilterModified={onFilterModified}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}